import React, { memo } from 'react'
import { Link, Button } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import { func, string } from 'prop-types'
import { serverData } from '../../utils'
const { locality = {} } = serverData
const directionality = locality.directionality || 'ltr'

export const PrivacyHubLink = memo(({ href, message, name, id }) => (
  <Message
    id={message}
    link={(innerMessage) => (
      <Link
        id={id}
        className="privacy-hub-link privacy-hub-hyper-link"
        href={href}
        name={name}
      >
        {innerMessage}
        <span className={`link-arrow-icon ${directionality}`} />
      </Link>
    )}
  />
))

PrivacyHubLink.propTypes = {
  href: string.isRequired,
  message: string.isRequired,
}

PrivacyHubLink.displayName = 'PrivacyHubLink'

export const PrivacyHubModalLink = memo(
  ({ message, onSectionClick, name, id }) => (
    <Message
      id={message}
      link={(innerMessage) => (
        <Button
          id={id}
          name={name}
          tertiary
          onClick={onSectionClick}
          className="privacy-hub-link privacy-hub-button-link privacy-hub-hyper-link"
        >
          {innerMessage}
          <span className={`link-arrow-icon ${directionality}`} />
        </Button>
      )}
    />
  ),
)

PrivacyHubModalLink.propTypes = {
  message: string.isRequired,
  onSectionClick: func.isRequired,
  id: string.isRequired,
}

PrivacyHubModalLink.displayName = 'PrivacyHubModalLink'
